/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Type of the device attribute
 */
export type CreateDeviceAttributeDtoType = (typeof CreateDeviceAttributeDtoType)[keyof typeof CreateDeviceAttributeDtoType];

export const CreateDeviceAttributeDtoType = {
  PROPERTY: 'property',
  REALTIME: 'realTime',
} as const;
